var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SpecimenSurveyQueryTab',{attrs:{"value":_vm.vegetativePlotDataSource}})
}
var staticRenderFns = []

export { render, staticRenderFns }